<template>
    <div class="data-container">
        <div class="tool-box">
            <el-button type="primary" :icon="Refresh" @click="getTableData">刷新</el-button>
            <el-button type="primary" :icon="Plus" plain @click="onAddClick()" v-permission="['base:team:add']">添加</el-button>
            <!-- <el-button :icon="Download" @click="importsVisible = true" v-permission="['base:dept:import']">导入</el-button>
                    <el-button :icon="Upload" @click="handleExport" v-permission="['base:dept:export']">导出</el-button> -->
            <!-- <el-button :icon="DCaret" @click="handleSort" v-permission="['base:dept:sort']">一键排序</el-button> -->
        </div>
        <el-table
            class="data-table"
            :data="table_data"
            row-key="id"
            default-expand-all
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            table-layout="auto"
        >
            <el-table-column label="序号" type="index" width="60" />
            <el-table-column prop="name" label="班组名称"></el-table-column>
            <el-table-column prop="status" label="状态">
                <template #default="{ row }">
                    <el-tag v-if="row.status" type="success">启用</el-tag>
                    <el-tag v-else type="danger">禁用</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="update_time" label="创建时间" width="180"></el-table-column>
            <el-table-column prop="list_order" label="排序" width="130">
                <template #default="scope">
                    <el-input-number
                        style="width: 100px"
                        type="number"
                        v-model="scope.row.list_order"
                        :min="0"
                        :max="999999"
                        controls-position="right"
                        size="small"
                    />
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="150">
                <template #default="{ row }">
                    <el-button type="primary" link :icon="Edit" @click="onEditClick(row)" v-permission="['base:team:edit']">
                        编辑
                    </el-button>
                    <el-button type="primary" link :icon="Delete" @click="onRemoveClick(row)" v-permission="['base:team:remove']">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-if="table_data.length > 0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForms.page"
            :page-sizes="[10, 20, 50]"
            :page-size="queryForms.page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>

        <forms-dialog v-model="formDialogVisible" :isForm="isForm" :teamId="teamId" @updateForm="getTableData"></forms-dialog>
        <!-- <ImportsForm v-model="importsVisible" @updateForm="getTableData" menuCode="department" /> -->
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import FormsDialog from './components/forms.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { delTeam, getTeamLists } from '@/api/teamManage/teamManage.js'
import { Delete, Edit, Plus, Refresh } from '@element-plus/icons'

// 数据源
const queryForms = ref({
    type: '',
    name: '',
    model: '',
    status: '',
    ip: '',
    area: '',
    page: 1,
    page_size: 10
})
const total = ref(0)
// 分页相关
// page_size 改变触发
const handleSizeChange = (currentSize) => {
    queryForms.value.page_size = currentSize
    getTableData()
}
// page 页码改变触发
const handleCurrentChange = (currentPage) => {
    queryForms.value.page = currentPage
    getTableData()
}

// 数据相关
const table_data = ref([{}])
// 获取数据的方法
const getTableData = async () => {
    const res = await getTeamLists()
    table_data.value = res.lists
    total.value = res.total
}
onMounted(() => {
    getTableData()
})

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const teamId = ref('') // 点中的模块id
// 保证每次打开重新获取用户角色数据
watch(formDialogVisible, (val) => {
    if (!val) teamId.value = ''
})
// 查看
// const onShowClick = (row) => {
//     teamId.value = row.id
//     isForm.value = false
//     formDialogVisible.value = true
// }
// 编辑
const onEditClick = (row) => {
    teamId.value = row.id
    isForm.value = true
    formDialogVisible.value = true
}
// 添加
const onAddClick = () => {
    teamId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}
// 删除

const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定要删除 ' + row.name + ' 吗？', {
        type: 'warning'
    })
        .then(async () => {
            await delTeam(row.id)
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getTableData()
        })
        .catch(() => {})
}

// // 导入
// const importsVisible = ref(false)

// // 导出
// const handleExport = () => {
//     ElMessageBox.confirm('是否确认导出部门列表', '提示', {
//         confirmButtonText: '确认',
//         cancelButtonText: '取消',
//         type: 'warning'
//     })
//         .then(async () => {
//             const data = await getDepartmentList({ export: 1 })
//             window.open(data.data)
//             ElMessage({
//                 type: 'success',
//                 message: '导出成功'
//             })
//         })
//         .catch(() => {})
// }
</script>

<style lang="scss" scoped>
// .el-table {
//     height: calc(100vh - 210px);
//     overflow-y: auto;
// }
</style>
